module.exports = __webpack_public_path__ + "images/b749ee3006ab14d8f6627d98369dba17-desk3.jpg";